import React from 'react';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Welcome</h1>
      </header>
    </div>
  );
}

export default App;
